/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { hideWhisperAction } from '../../store/whisper/whisper.actions';
import { WhisperProps } from './WhisperProps';
import { WHISPER_ACTIVE_TIME } from '../../config';
import { RootState } from '../../store/root.reducers';

import './Whisper.scss';

const Whisper: FunctionComponent<WhisperProps> = (props): JSX.Element => {
    const { message } = props;
    const { isWhisperActive } = useSelector((state: RootState) => state.whisper);
    const [isActive, setIsActive] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        if (isWhisperActive) {
            setIsActive(true);
            setTimeout(() => {
                dispatch(hideWhisperAction());
            }, WHISPER_ACTIVE_TIME);
        }
    }, [isWhisperActive]);

    return (
        <div className={`whisper-container ${!isActive ? 'hidden' : ''}`}>
            <div className={`whisper ${isWhisperActive ? 'show-whisper' : 'hide-whisper'}`}>
                <div className="icon-section info"></div>
                <div className="seperator-image"></div>
                <div className="message">{message}</div>
            </div>
        </div>
    );
};

Whisper.propTypes = {
    message: PropTypes.any,
};

export default Whisper;
